import {BrowserRouter} from "react-router-dom";
import {checkLogin} from './shared/utils/auth/authenticate';
import ProtectedRoutes from "./components/ProtectedRoutes";
import RestrictedRoutes from "./components/RestrictedRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          {
              checkLogin() ? <ProtectedRoutes/> : <RestrictedRoutes/>
          }
      </BrowserRouter>
    </div>
  );
}

export default App;
